/** @module csi/heading/TimeController */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dijit/form/_TextBoxMixin",
	"./InlineController"
], function(declare,lang,_TextBoxMixin,InlineController) {

	return declare(InlineController, {
		/**
		 * Highlight text when focused and open Calendar if invoked from click event
		 * @param {_WidgetBase} editNode
		 */
		onShowEditNode: function(editNode) {
			if (editNode.focusNode) {
				_TextBoxMixin.selectInputText(editNode.focusNode);
			}

			if (this.bClick) {
				// if value was selected with the mouse and the attribute was opened for editing
				// with the mouse, then start processing new value
				editNode.set("clicked", true);

				// see _HasDropDown::_onKeyUp
				editNode.toggleDropDown();
				var d = editNode.dropDown;
				if (d && d.focus) {
					editNode.defer(lang.hitch(d, "focus"), 1);
				}
			}
		},

		/**
		 * Compare formatted values in addition to actual values to make sure not changing Date when only hour changes (due to timezone)
		 * @return {boolean}
		 */
		_isValueChanged: function() {
			if (!this.inherited(arguments)) {
				return false;
			}

			var ctx = this.getContext();
			var ren = this.ren;
			var fmt = ren._getFormat(ctx, this.heading);

			return ren.formatValue(this.newValue, fmt) != ren.formatValue(this.oldValue, fmt);
		},

		/**
		 * Listen for events on widget
		 * @param {Context} ctx
		 * @param {Object} params
		 * @return {_WidgetBase}
		 */
		_toHtmlDynamic: function(ctx, params) {
			var	editNode = this.inherited(arguments);

			this._connectEvent(editNode, "onBlur", "_onProcess");
			this._connectEvent(editNode, "onTextBoxInput", "_onInput");

			// if edit started with click, then process value on click; if using keyboard, then click will just close the calendar drop-down
			if (this.bClick) {
				this._connectEvent(editNode, "onClicked", "_onProcess");
			}
			
			return editNode;
		}
	});
});